/* components/CollectionSorting
- Used within collection and search templates
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { FakeDropdown } from '@/components/FakeDropdown/FakeDropdown';

@Component
export class CollectionSorting extends ThemeComponent {
    @Ref fakeDropdown!: FakeDropdown;

    init() {
        this.handleActiveSort();
    }

    handleActiveSort() {
        const queryString = window.location.search;

        if (queryString.indexOf('sort_by=') > -1) {
            const params = new URLSearchParams(queryString);
            const sortValue = params.get('sort_by');

            const selected = this.fakeDropdown.querySelector(`.fake-dropdown__option[data-value=${sortValue}]`);
            selected?.classList.add('fake-dropdown__option--selected');
        }
    }

}
